import React from 'react';
// import AttachmentsComponent from '../../../Elements/AttachmentsComponent';
import GeneralEntryLogFigma from '../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../Elements/CommentsEntryLogDescription';
import TabbedPage from '../../../Elements/TabbedPage';
// import LogComponent from '../../../Elements/LogComponent';
import FraudHitEvaluatorTab from './FraudHitEvaluatorTab';
import BaseEvaluatorTab from './BaseEvaluatorTab';

export default class FraudHitDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
    this.topPaneRef = React.createRef();
  }

  componentDidMount() {
    // Refit the lower grid whenever the top pane's height changes — tab switch (Base Shopper ↔
    // Comments), async comment load, grid data replacing the loading block. TabOfDataTable
    // re-runs its height-fit on window resize; the fit is idempotent, so the observer can't loop.
    // (The global ResizeObserver wrapper in Helpers/patchResizeObserver.js already defers every
    // callback a frame, so the dispatch no longer needs its own requestAnimationFrame.)
    this.topPaneObserver = new ResizeObserver(() => window.dispatchEvent(new Event('resize')));
    if (this.topPaneRef.current) this.topPaneObserver.observe(this.topPaneRef.current);
  }

  componentWillUnmount() {
    if (this.topPaneObserver) this.topPaneObserver.disconnect();
  }

  urlParams = new URLSearchParams(window.location.search);
  fraudHitId = this.urlParams.get('fraudHitId');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('fraudHitId');
    return `Fraud Hit ${id ? `- ${id}` : 'Details'}`;
  }

  baseTab = [
    {
      label: 'Base Shopper',
      id: 'baseevaluator',
      icon: 'fa-solid fa-file-invoice',
      component: <BaseEvaluatorTab fraudHitId={this.fraudHitId} />,
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comments',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 10009, entityId: this.fraudHitId }}
        />
      ),
    },
  ];

  // prettier-ignore
  tabs = [
    { label: "Matched Shoppers", id: "fraudhitevaluators", icon: "fa-solid fa-file-invoice", component: <FraudHitEvaluatorTab fraudHitId={this.fraudHitId} /> },
    // { label: "Attachments", id: "attachments", icon: "fa-solid fa-paperclip", component: <AttachmentsComponent entityTypeId={36} entityId={this.recordId} enableAddNew={true} /> },
    // { label: "Logs", id: "logs", icon: "fa-solid fa-stream", component: <LogComponent entityType="FraudHit" entityId={this.recordId} />}
];

  render() {
    // Stacked grids: the auto-height .grid-fit-bounds wrapper caps the Base Shopper grid at its
    // natural (content) height — without it, TabOfDataTable's viewport-fit would stretch the
    // FIRST grid to the page bottom. The lower Matched Shoppers grid is left unwrapped so that
    // same viewport-fit stretches IT to the page bottom instead; the ResizeObserver on the top
    // pane (componentDidMount) keeps it in sync when the pane's height changes.
    return (
      <div className='contentwrapper'>
        {/* className='' drops TabbedPage's legacy "border rounded opacity70" card, whose
            translucent white fill reads as a grey band behind the tab content on dark mode.
            (The usual .TabbedPage wrapper hook is unusable here: its legacy Style.css rule
            `position: inherit; top: 80px` breaks this page's stacked-pane flow.) */}
        <div
          className='grid-fit-bounds'
          ref={this.topPaneRef}
        >
          <TabbedPage
            tabs={this.baseTab}
            className=''
          />
        </div>
        <TabbedPage
          tabs={this.tabs}
          className=''
        />
      </div>
    );
  }
}
